import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate, useSearchParams } from "react-router-dom";
import Menu from "../../../Layout/Menu/Menu";
import VenuesApprovalRequests from "./VenuesApprovalRequests";
import NavBar from "../../../../components/NavBar";

const VenuesApprovalView = () => {
    let params = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [state, setState] = useState({
        id: 0,
        name: "",
        description: "",
        phone_country: "",
        phone_number: "",
        link_facebook: "",
        link_instagram: "",
        street_name: "",
        municipality: "",
        district: "",
        country: "",
        postal_code: "",
        latitude: "",
        longitude: "",
        date_create: "",
        date_update: "",
        type: "",
        images: [],
        validation: {
            warning: [],
            danger: []
        }
    })
    useEffect(async () => {
        setIsLoading(true);
        let info = await VenuesApprovalRequests.getVenuesApprovalInfo(params);
        if (info && info.status) {
            setState(info.data);
            setIsLoading(false);
        }
    }, [])


    const handlerApproveVenue = async () => {
        let response = await VenuesApprovalRequests.approveVenue(params);
        if (response && response.status) {
            navigate(`/my/admin/venues-approval/`);
        }
    }

    return (
        <div>
            <NavBar>
                <div className="row">
                    <div className="col-12 dashboard-content">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="dashboard-h2"><Link to="/my/admin/venues-approval/" className="link-nostyle" style={{ fontSize: "0.9em" }}><i className="fa-solid fa-arrow-left"></i> BACK</Link> </h2>
                            </div>

                        </div>
                        <div className="row" style={{ display: state.validation.danger.length > 0 ? 'block' : 'none' }}>
                            <div className="col-12">
                                <div className="alert alert-danger" role="alert">
                                    <h4 className="alert-heading">Don't Aprove!</h4>
                                    Venue in progress to complete
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6 " >
                                <label className="form-label" style={{ fontWeight: "bold" }}>Name</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.name}></input>
                            </div>
                            <div className="col-3 " >
                                <label className="form-label" style={{ fontWeight: "bold" }}>Create Date</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.date_create}></input>
                            </div>
                            <div className="col-3 " >
                                <label className="form-label" style={{ fontWeight: "bold" }}>Update Date</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.date_update}></input>
                            </div>

                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-12">
                                <label className="form-label" style={{ fontWeight: "bold" }}>Description</label>
                                <textarea type="text" readonly className="form-control-plaintext text-light" rows={8} value={state.description}></textarea>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-4">
                                <label className="form-label" style={{ fontWeight: "bold" }}>Phone</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={`${state.phone_country} ${state.phone_number}`}></input>
                            </div>
                            <div className="col-4">
                                <label className="form-label" style={{ fontWeight: "bold" }}>Facebook</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.link_facebook}></input>
                            </div>
                            <div className="col-4">
                                <label className="form-label" style={{ fontWeight: "bold" }}>Instagram</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.link_instagram}></input>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-6">
                                <label className="form-label" style={{ fontWeight: "bold" }}>Street</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.street_name}></input>
                            </div>
                            <div className="col-2">
                                <label className="form-label" style={{ fontWeight: "bold" }}>Municipality</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.municipality}></input>
                            </div>
                            <div className="col-2">
                                <label className="form-label" style={{ fontWeight: "bold" }}>district</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.district}></input>
                            </div>
                            <div className="col-2">
                                <label className="form-label" style={{ fontWeight: "bold" }}>country</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.country}></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <label className="form-label" style={{ fontWeight: "bold" }}>Postal Code</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.postal_code}></input>
                            </div>
                            <div className="col-4">
                                <label className="form-label" style={{ fontWeight: "bold" }}>latitude</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.latitude}></input>
                            </div>
                            <div className="col-4">
                                <label className="form-label" style={{ fontWeight: "bold" }}>longitude</label>
                                <input type="text" readonly className="form-control-plaintext text-light" value={state.longitude}></input>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <label className="form-label" style={{ fontWeight: "bold" }}>type</label>
                            <input type="text" readonly className="form-control-plaintext text-light" value={state.type}></input>
                        </div>
                        <hr />
                        <div className="row">
                            {state.images.map((item) => {
                                return (
                                    <div className="col-6">
                                        <img src={item.base64} class="img-thumbnail" alt="..."></img>
                                        {item.type}
                                    </div>
                                )
                            })}
                        </div>
                        <hr />
                        <div className="row" style={{ marginTop: "100px" }}>
                            <div className="col-6">
                                <button className="btn btn-danger w-100">Reprovar</button>
                            </div>
                            <div className="col-6">
                                <button className="btn btn-success w-100" onClick={handlerApproveVenue}>Aprovar</button>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "100px" }}>&nbsp;</div>
                    </div>
                </div>
            </NavBar>
        </div>
    )
}

export default VenuesApprovalView;